import { useContext } from "react";
import { GableSide } from "../../models/GableSide";
import { GableType } from "../../models/GableType";
import { hasDimensions } from "../../services/CabinetValidator";
import { FrontPosConverter } from "../../util/PosConverter";
import { DrawContext } from "../EditorCommon/DrawContext";
import { EditorContext } from "../EditorCommon/EditorContext";
import { ImageOutline } from "../EditorCommon/ImageOutline";


export function GableImage(props: {
    onClick?: (() => void),
    side: GableSide,
}) {

    const ec = useContext(EditorContext);
    const drawContext = useContext(DrawContext);

    const cabinet = ec.cabinet;
    if (!hasDimensions(cabinet))
        throw new Error("dimensions not defined");

    const gableInfo = ec.cabinetService.getGableInfo();

    const convert = new FrontPosConverter(cabinet.height!);

    const side = props.side === GableSide.Left
        ? gableInfo.left
        : gableInfo.right;
    if (side.type === GableType.None)
        return null;


    const matId = props.side === GableSide.Left
        ? cabinet.leftGableMaterialId
        : cabinet.rightGableMaterialId;
    const materials = ec.cabinetService.getGableMaterials(props.side);
    const material = materials?.find(mat => mat.id === matId);

    return (
        <g className={`gable gable-image ${props.onClick ? 'clickable' : ''}`}
            onClick={() => props.onClick?.()}
        >
            <image {...convert.obj(side)}
                xlinkHref={material?.textureImageUrl ?? undefined}
                preserveAspectRatio={drawContext.preserveAspectRatio}
            />
            <rect {...convert.obj(side)} {...ImageOutline} />
        </g >
    );

}

